<div class="grid-container">
    @for (field of mappedFields(); track $index) {
        <div
            [style.gridColumnStart]="field.baseField.x + 1"
            [style.gridColumnEnd]="'span ' + field.baseField.cols"
            [style.gridRowStart]="field.baseField.y + 1"
            [style.gridRowEnd]="'span ' + field.baseField.rows">
            @switch (field.baseField.type) {
                @case (FIELD_TYPES.Annotation) {
                    <app-froala [content]="$any(field.value)" [editmode]="false" />
                }
                @case (FIELD_TYPES.Table) {
                    <cipo-table-field-view
                        [entityInstanceId]="entityInstanceId()"
                        [includeHistory]="includeHistory()"
                        [tableField]="$any(field.baseField)" />
                }
                @case (FIELD_TYPES.Weather) {
                    <cipo-table-field-view
                        [entityInstanceId]="entityInstanceId()"
                        [includeHistory]="includeHistory()"
                        [tableField]="$any(field.baseField)" />
                }
                @default {
                    <cipo-text-view
                        [config]="field.config"
                        [value]="field.value"
                        [readonlyConfig]="field.readonlyConfig" />
                }
            }
        </div>
    }
</div>
